import React, { useState, useRef } from 'react'
import { Route, Routes } from 'react-router-dom'
import Home from './components/Home'
import About from './components/About'
import Products from './components/Products'
import ExcutiveTeam from './components/ExcutiveTeam'
import Contact from './components/Contact'
import Video from './components/Video'
import News from './components/News'
import Interview from './components/Interview'
import Main from './components/admin/Main'
import CompanyHistory from './components/CompanyHistory'
import TokencoinListing from './components/TokencoinListing'
import Services from './components/Services'
import Login from './components/Login'
import BusinessUseCase from './components/BusinessUseCase'
import ask from './img/ask_robot.png'
import { FaRobot, FaUserCircle, FaWindowClose } from "react-icons/fa";
import { Button, Box, Typography, Paper, Avatar, Stack } from '@mui/material';
import { TextField, IconButton, InputAdornment, CircularProgress } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import axios from 'axios'
import logo from './img/smartcard_logo.png'
import { deepOrange, green } from '@mui/material/colors';
import Skeleton from '@mui/material/Skeleton';
import DOMPurify from 'dompurify';
import ButtonList from './ButtonList'
import Focus from './Focus'
import MessageForm from './MessageForm'
import { FiSend } from "react-icons/fi";


function App() {
  const [showChat, setShowChat] = useState(false);
  const [message, setMessage] = useState('');
  const inputRef = useRef(null);

  const [messageList, seMessageList] = useState([
    {
      id: 1,
      message: `Welcome to SmartCard marketing Systems Inc,
      I am genie , your virtual assistant and I am here to help you
      Let me know How can I help you.
      `,
      sender: 'robot'
    },
    {
      id: 2,
      message: 'show_button_list',
      sender: 'robot'
    }
  ]);
  const [start, setStart] = useState(true);
  const [loading, setLoading] = useState(false);


  const clcikData = (data) => {
    if (data === 2 || data === 3) {
      for (let i = 0; i < messageList.length; i++) {
        if (messageList[i].message === 'show_From') {
          return
        }
      }
      console.log(messageList)
      var newL = {
        id: 3,
        message: 'show_From',
        sender: 'robot'
      }
      seMessageList((prevMessages) => [...prevMessages, newL]);
      console.log(messageList)
      return;
    }
    console.log(data)
    console.log(inputRef.current)

    if (inputRef.current) {
      inputRef.current.focus();
    }
  };
  const handleSend = async () => {
    setLoading(true)
    const mainLIst = messageList;
    const idu = `responseu-${Date.now()}`;
    const newUStmess = {
      id: idu,
      message: ` ${message}. `,
      sender: 'user',
    };
    mainLIst.push(newUStmess)

    seMessageList(mainLIst)
    console.log(messageList)

    if (message.trim()) {


      try {
        //const response = await axios.get('https://smartcardmarketingsystems.com/api/chatbot.php?message=' + message + '&start=' + start);
        fetch('http://botgcp.botberries.com/api/ask-mongodb', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            question: message
          }),
        })
          .then(response => {
            setLoading(false)
            setStart(false)
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
            
            console.log(response)
            //
            return response.json();
          })
          .then(data => {
            console.log('Response from API:', data); // answer
            const newStepId = `response-${Date.now()}`;
            const newStep = {
              id: newStepId,
              message: ` ${data.answer}. `,
              sender: 'robot',
            };

            var steepList = messageList;
            steepList.push(newStep)
            console.log(steepList)
            seMessageList(steepList)
            

          })
          .catch(error => {
            console.error('Error:', error);
          });



      } catch (error) {
        console.error('Error sending data:', error);
      }

      setMessage('');
    }
  };
  const getFLoading = (data) => {
    console.log(data)
    setLoading(data)
  }
  const getFormSubmitStatus = (data) => {
    console.log(data)
    if (data == 1) {
      var newData = {
        id: 3,
        message: 'Tahnk you!',
        sender: 'robot'
      }
      seMessageList((prevMessages) => [...prevMessages, newData]);
    }
    // setLoading(data)
  }


  return (
    <div>
      <Routes>
        <Route path='/' element={<Home />}></Route>
        <Route path='/about' element={<About />}></Route>
        <Route path='/business-use-case' element={<BusinessUseCase />}></Route>
        <Route path='/login' element={<Login />}></Route>
        <Route path='/products' element={<Products />}></Route>
        <Route path='/executiveteam' element={<ExcutiveTeam />}></Route>
        <Route path='/contact' element={<Contact />}></Route>
        <Route path='/video' element={<Video />}></Route>
        <Route path='/news' element={<News />}></Route>
        <Route path='/interview' element={<Interview />}></Route>
        <Route path='/company-history' element={<CompanyHistory />}></Route>
        <Route path='/token-coin-listing' element={<TokencoinListing />}></Route>
        <Route path='/services' element={<Services />}></Route>
        {/* <Route path='/admin' element={<Main />}></Route> */}
        {/* <Route path='/admin/*' element={<Main />}></Route> */}
        <Route path='/dashboard/*' element={<Main />} ></Route>
      </Routes>


      <div className='chatbot-all'>
        {showChat &&
          <div className='ctabot-form-box'>
            <div className='header-window'>
              <div>
                <img src={logo} className='header-logo' />
              </div>
              <div>
                <button onClick={() => { setShowChat(!showChat) }}>
                  <FaWindowClose color='red' size={20} />
                </button>
              </div>
            </div>

            <Box className="chatbot-contern-area"
              sx={{
                overflowY: 'auto',
                border: '1px solid #ddd',
                borderRadius: '4px',
                '&::-webkit-scrollbar': {
                  width: 8,
                },
                '&::-webkit-scrollbar-thumb': {
                  backgroundColor: '#888',
                  borderRadius: 4,
                },
                '&::-webkit-scrollbar-thumb:hover': {
                  backgroundColor: '#555',
                },
              }}
            >
              {messageList.length > 0 &&
                <>
                  {messageList.map((list, i) => (
                    <Box key={i}
                      sx={{
                        display: 'flex',
                        flexDirection: list.sender === 'user' ? 'row-reverse' : 'row',
                        marginBottom: 2,
                      }}
                    >
                      {list.sender === 'user' &&
                        <Avatar sx={{ margin: 1, bgcolor: deepOrange[500] }} >
                          <FaUserCircle />
                        </Avatar>}
                      {list.sender === 'robot' &&
                        <Avatar sx={{ margin: 1, bgcolor: green[500] }} >
                          <FaRobot />
                        </Avatar>
                      }

                      <Paper
                        sx={{
                          padding: 2,
                          maxWidth: '70%',
                          backgroundColor: list.sender === 'user' ? '#c8e6c9' : '#e3f2fd',
                          borderRadius: 2,
                          boxShadow: 1,
                        }}
                      >
                        {/*  props.fomrLoading(false)
                              props.fomrStatus(1)
                              */}
                        <Typography variant="body2" sx={{ wordWrap: 'break-word' }}>
                          {list.message === 'show_button_list' ? (<ButtonList getData={clcikData} />) : list.message === 'show_From' ? (
                            <MessageForm fomrLoading={getFLoading} fomrStatus={getFormSubmitStatus} />
                          ) : list.message}
                          {/* {list.message === 'show_From' ? <MessageForm /> : list.message} */}

                          {/* {props.status === 'loading' ? (
                            <LoadingSpinner />
                          ) : props.status === 'error' ? (
                            <ErrorMessage />
                          ) : (
                            <DataDisplay data={props.data} />
                          )} */}

                          {/* <div
                            dangerouslySetInnerHTML={{
                              __html: DOMPurify.sanitize(),
                            }}
                          /> */}

                        </Typography>
                      </Paper>
                    </Box>
                  ))}
                </>
              }
              {loading &&
                <>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      marginBottom: 2,
                    }}
                  >
                    <Avatar sx={{ margin: 1, bgcolor: green[500] }} >
                      <FaRobot />
                    </Avatar>
                    <Paper
                      sx={{
                        padding: 2,
                        maxWidth: '70%',
                        backgroundColor: '#e3f2fd',
                        borderRadius: 2,
                        boxShadow: 1,
                        width: '100%'
                      }}
                    >
                      <Typography variant="body2" sx={{ wordWrap: 'break-word' }}>
                        <Skeleton />
                        <Skeleton animation="wave" />
                        <Skeleton animation={false} />
                      </Typography>
                    </Paper>
                  </Box>
                </>
              }



              {/* <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  marginBottom: 2,
                }}
              >
                <Avatar sx={{ margin: 1 }}>
                  {'B'}
                </Avatar>
                <Paper
                  sx={{
                    padding: 2,
                    maxWidth: '70%',
                    backgroundColor: '#e3f2fd',
                    borderRadius: 2,
                    boxShadow: 1,
                  }}
                >
                  <Typography variant="body2" sx={{ wordWrap: 'break-word' }}>
                    Ok \n sdsd <p>dd</p>
                  </Typography>
                </Paper>
              </Box> */}
            </Box>


            <div className='mlr-5'>
              <TextField
                label="Type your message"
                variant="outlined"
                value={message}
                ref={inputRef}
                onChange={(e) => setMessage(e.target.value)}
                id="inputmessage"
                fullWidth
                size="small"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={handleSend}
                        disabled={!message.trim()}
                        size="small"
                      >
                        {loading &&
                          <CircularProgress color="secondary" size="20px" />
                        }
                        {!loading &&
                          <FiSend size="20" />
                        }

                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>
          </div>
        }
        {!showChat &&
          <div className='chatbot-logo-box'>
            <img src={ask} alt='' className='ask-logo'
              onClick={() => { setShowChat(!showChat) }} />
          </div>
        }
      </div>

    </div >
  )
}

export default App
